// react
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";

// kendo
import kendo from "@progress/kendo-ui";
import { Dialog, DialogActionsBar, Window, WindowActionsBar } from '@progress/kendo-react-dialogs';

// css
import styles from './header_mobile.module.css';
import './header_mobile.css';

// services
import { getAccountInfo, setUpdateAccountInfo } from '../../service/mngt/accoutMngtService';
import { authGuest, setDelToken, setToken, isLogin, getUser, isUser, isProtector, delAdmToken } from "../../service/authService";

function HeaderMobile({conn, loginStatus, setUpdateLoginStatus, state}) {
  const location = useLocation();
  const history = useHistory();
  const userInfo = getUser();

  const [title, setTitle] = useState("");
  // 뒤로가기 버튼 설정
  const [back, setBack] = useState(true);

  const [menuList, setMenuList] = useState([
    { menuTerm: "대상자 목록", menuUrl: "/user/list" },
    { menuTerm: "대상자 정보", menuUrl: "/user/info" },
    { menuTerm: "대상자 위치", menuUrl: "/user/location" },
    { menuTerm: "대상자 상세정보", menuUrl: "/user/info/detail" },
    { menuTerm: "모니터링 상세정보", menuUrl: "/user/info/monitor" },
    { menuTerm: "대상자 등록", menuUrl: "/add" },
    { menuTerm: "대상자 수정", menuUrl: "/update" },
    { menuTerm: "내 정보", menuUrl: "/account" },
    { menuTerm: "알림 이력", menuUrl: "/noti/history" },
    { menuTerm: "상태/이벤트 도움말", menuUrl: "/help" },
    { menuTerm: "알림 이력", menuUrl: "/notiLog" },
    { menuTerm: "알림 이력", menuUrl: "/notiLogDetail" },
    { menuTerm: "현장 사진", menuUrl: "/user/info/placePhoto" },
    { menuTerm: "사진 추가/수정", menuUrl: "/user/info/changePhoto" },
  ]);

  // DIALOG 설정
  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);
  const [questionDialogVisible, setQuestionDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("확인을 눌러주세요.");

  const saveQuestionDialog = () => {
    // delAdmToken(conn, userInfo.userId);
    setDelToken();
    authGuest(conn).then(result => {
      setToken(result.token);
      setUpdateLoginStatus(false);
      history.push("/");
    });
    setQuestionDialogVisible(false);
  }
  const closeCompleteDialog = () => {
    setCompleteDialogVisible(false);
  }
  const closeQuestionDialog = () => {
    setQuestionDialogVisible(false);
  };

  
  // 제목 클릭 -> 메인화면 이동
  const clickTitle = () => {
    if(isUser() || isProtector) {
      history.push("/user/info");
    } else {
      history.push("/user/list");
    }
  };

  // 왼쪽 상단 버튼 (뒤로가기)
  const clickBackButton = () => {
    history.goBack();
  };

  // 왼쪽 상단 버튼 (대상자 등록 버튼)
  const goAddUser = () => {
    if(userInfo.userTypeCode === 2001) {
      setCompleteDialogVisible(true);
      return;
    } else {
      history.push({
        pathname: "/add",
      });
    }
  }

  const lat = state.lat;
  const lng = state.lng;
  const userTerm = state.userTerm;
  const userId = state.userId;
  const fileIdUserPhoto = state.fileIdUserPhoto;
  const userGender = state.userGender;
  // 오른쪽 상단 버튼 (맵이동)
  const showLocation = () => {

      
    // if(userInfo.userId === "jktest1" || userInfo.userId === "jktest3" || userInfo.userId === "developer") {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          history.push({
            pathname: "/user/location",
            state: { lat, lng, userTerm, userId, fileIdUserPhoto, userGender },
          });
        })
      }
    // } else {  
    //   if ('geolocation' in navigator) {
    //     navigator.geolocation.getCurrentPosition((position) => {
    //       setDialogMessage("준비중입니다.");
    //       setCompleteDialogVisible(true);
    //     })
    //   }
    // }
  };

  // 오른쪽 상단 버튼 (로그아웃)
  const logout = () => {
    setDialogMessage("로그아웃 하시겠습니까?");
    setQuestionDialogVisible(true);
  };

  // 오른쪽 상단 버튼 (대상자 전화)
  const callUser = () => {
    return document.location.href='tel:' + state.userPhone;
  };

  // 오른쪽 상단 버튼 (상태/이벤트 도움말 표출)
  const showHelp = () => {
    history.push("/help");
  };

  // 오른쪽 상단 버튼 (대상자 수정)
  const updateUser = () => {
    if(userInfo.userTypeCode === 2001) {
      setDialogMessage("보호자는 이용할 수 없습니다.")
      setCompleteDialogVisible(true);
    } else {
      history.push({
        pathname: "/update",
        state: { state },
      });

    }
  }


  useEffect(() => {
    // 제목 설정
    const current = menuList.find(m => m.menuUrl === window.location.pathname);
    setTitle(current.menuTerm);

    // 뒤로가기 버튼 설정
    if(isUser() || isProtector()) { // 보호자
      // 상태/이벤트 도움말, 대상자 상세정보, 대상자 모니터링 상세정보,
      if(location.pathname === '/user/info/detail' || location.pathname === '/user/info/monitor' || location.pathname === '/help' || location.pathname === '/user/location' || location.pathname === '/user/info/placePhoto' || location.pathname === '/user/info/changePhoto' || location.pathname === '/notiLogDetail') {
        setBack(true)
      } else {
        setBack(false)
      }
    } else { // 관리자
      // 상태/이벤트 도움말, 대상자 정보, 대상자 상세정보, 대상자 모니터링 상세정보,
      if(location.pathname === '/user/info' || location.pathname === '/user/info/detail' || location.pathname === '/add' || location.pathname === '/user/info/monitor' || location.pathname === '/help' || location.pathname === '/user/location' || location.pathname === '/update' || location.pathname === '/user/info/placePhoto' || location.pathname === '/user/info/changePhoto' || location.pathname === '/notiLogDetail') {
        setBack(true)
      } else {
        setBack(false)
      }
    }
  }, [location.pathname]);

  return (
    <>
      <header className={styles.headerMain_m}>
        <div className={styles.headerLeft_m}>
          {back ? 
            <img className={styles.backButton_m} src="/images/mobile/back.png" onClick={clickBackButton}></img>
            :
            null
          }
          {location.pathname === '/user/list' ?
            <img className={styles.subButton_m} src="/images/mobile/add3.png" onClick={goAddUser}></img>
            : null
          }
        </div>
        <div className={styles.headerCenter_m}>
          <div className={styles.headerTitle_m}>{title}</div>
        </div>
        <div className={styles.headerRight_m}>
          {location.pathname === '/account' ?
            <img className={styles.subButton_m} src="/images/mobile/logout.png" onClick={logout}></img>
            :
            location.pathname === '/user/info' ?
            <>
            <img className={styles.subButton_m} src="/images/mobile/location.png" onClick={showLocation}></img>
            <img className={styles.subButton2_m} src="/images/mobile/call_btn.png" onClick={callUser}></img>
            </>
              :
              location.pathname === '/user/list' ?
                <img className={styles.subButton_m} src="/images/mobile/help.png" onClick={showHelp}></img>
                : null
          }
          {location.pathname === '/user/info/detail' &&
            <img className={styles.subButton_m} src="/images/mobile/update.png" onClick={updateUser}></img>
          }
        </div>
        {questionDialogVisible && (
          <Dialog
            className="completeDialog"
            width={"90vw"}
            height={"40vw"}
            closeIcon={false}
          >
            <p>
              {dialogMessage}
              <br></br>
              <button onClick={saveQuestionDialog}>확인</button>
              <button style={{ color: "black", background: "#dddddd", marginLeft: "2vw"}} onClick={closeQuestionDialog}>취소</button>
            </p>
          </Dialog>
        )}
        {completeDialogVisible && (
          <Dialog
            className="completeDialog"
            width={"90vw"}
            height={"40vw"}
            closeIcon={false}
          >
            <p>
              {dialogMessage}
              <br></br>
              <button onClick={closeCompleteDialog}>확인</button>
            </p>
          </Dialog>
        )}
      </header>
    </>
  );
}

export default HeaderMobile;
